module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-redis-01-m-jp.5e9128f954873c65145b186f0e3ecdfd.png";